import React from "react";
import {
  Search,
  Star,
  Heart,
  Users,
  ArrowRight,
} from "lucide-react";

const features = [
  {
    icon: Search,
    title: "Discover",
    text: "Find great businesses near you.",
    color: "#ef4444",
    bg: "#fee2e2",
  },
  {
    icon: Star,
    title: "Read Reviews",
    text: "See what others are saying.",
    color: "#f59e0b",
    bg: "#fef3c7",
  },
  {
    icon: Heart,
    title: "Save Favorites",
    text: "Keep your preferred businesses handy.",
    color: "#10b981",
    bg: "#d1fae5",
  },
  {
    icon: Users,
    title: "Connect",
    text: "Build a stronger local community.",
    color: "#3b82f6",
    bg: "#dbeafe",
  },
];

export default function WhyChoose() {
  return (
    <section
      id="about"
      className="w-full bg-white py-8 sm:py-10 lg:py-12"
    >
      <div className="mx-auto w-full max-w-[1400px] px-2 sm:px-4">
        {/* Main Container */}
        <div
          className="
            rounded-[20px]
            bg-[#eef7ff]
            px-8
            py-10
            sm:px-10
            sm:py-11
            lg:px-[42px]
            lg:py-[44px]
          "
        >
          <div
            className="
              grid
              items-center
              gap-10
              lg:grid-cols-[0.95fr_1.35fr]
              lg:gap-[58px]
            "
          >
            {/* Left Content */}
            <div className="max-w-[500px]">
              <h2
                className="
                  mb-4
                  text-[32px]
                  font-extrabold
                  leading-[1.15]
                  tracking-[-0.8px]
                  text-[#111c35]
                  sm:text-[34px]
                "
              >
                Why Choose BizNep?
              </h2>

              <p
                className="
                  mb-8
                  max-w-[500px]
                  text-[17px]
                  leading-[1.42]
                  text-[#50627d]
                "
              >
                BizNep makes it easy to find, explore and support local
                businesses. We help local businesses grow and build a stronger
                community together.
              </p>

              <button
                type="button"
                className="
                  inline-flex
                  h-[60px]
                  items-center
                  gap-3
                  rounded-[9px]
                  bg-[#0866c9]
                  px-[32px]
                  text-[17px]
                  font-bold
                  text-white
                  transition-colors
                  hover:bg-[#075bb5]
                "
              >
                Join Our Community

                <ArrowRight
                  size={20}
                  strokeWidth={2}
                />
              </button>
            </div>

            {/* Features */}
            <div
              className="
                grid
                grid-cols-1
                gap-x-[54px]
                gap-y-[28px]
                sm:grid-cols-2
              "
            >
              {features.map(
                ({ icon: Icon, title, text, color, bg }) => (
                  <div
                    key={title}
                    className="
                      flex
                      min-w-0
                      items-start
                      gap-[20px]
                    "
                  >
                    {/* Icon */}
                    <div
                      className="
                        flex
                        h-[72px]
                        w-[72px]
                        shrink-0
                        items-center
                        justify-center
                        rounded-full
                      "
                      style={{
                        backgroundColor: bg,
                      }}
                    >
                      <Icon
                        size={34}
                        strokeWidth={2}
                        style={{
                          color: color,
                        }}
                      />
                    </div>

                    {/* Text */}
                    <div className="pt-[7px]">
                      <h3
                        className="
                          mb-[7px]
                          text-[20px]
                          font-bold
                          leading-[1.15]
                          tracking-[-0.3px]
                          text-[#111c35]
                        "
                      >
                        {title}
                      </h3>

                      <p
                        className="
                          max-w-[205px]
                          text-[16px]
                          leading-[1.45]
                          text-[#50627d]
                        "
                      >
                        {text}
                      </p>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}